/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  name: z.string(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionMethodBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionMethodBase = z.infer<typeof base>;
export type ConstructionMethodBasePutPayload = z.infer<typeof put>;
export type ConstructionMethodBasePatchPayload = z.infer<typeof patch>;
export type ConstructionMethodBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionMethodBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionMethodBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionMethodBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionMethodBaseCachesAttributes = z.infer<typeof caches>;